import { Type } from 'class-transformer'
import { BaseEntity } from './base'
import type { PagingQuery } from './common'
import type { Court } from './court'
import { Portfolio } from './portfolio'
import type { CivilProcedureRegime, CourtRegistry, JudicialDegree, NewPracticeAssignment } from './practice'
import type { PracticePhase, PracticeTypeRow } from './practice-type'
import { AssignedRecordType, NewAssignedRecordType } from './record-type'

export class CasePractice extends BaseEntity {
  displayName!: string
  archiveNumber!: string
  externalId!: string | null
  registry?: CourtRegistry | null
  generalRoleNumber?: string | null
  parentId!: string | null
  mergedIntoId!: string | null

  type!: PracticeTypeRow
  phase!: PracticePhase
  court?: Court | null
}

export class BaseCase extends BaseEntity {
  displayName!: string
  eurValue!: string | null
  externalId!: string | null
  portfolioId!: string | null
}

export class Case extends BaseCase {
  @Type(() => CasePractice)
  practices!: CasePractice[]

  @Type(() => Portfolio)
  portfolio?: Portfolio | null
}

export interface GetCasesQuery extends PagingQuery {
  searchString?: string
  externalId?: string
  portfolioId?: string
}

export interface GetCases {
  cases: BaseCase[]
  hasNextPage: boolean
}

export interface GetCase {
  case: Case
}

class NewFirstPractice {
  displayName!: string
  archiveNumber!: string
  registry!: CourtRegistry | null
  generalRoleNumber!: string | null
  judicialDegree!: JudicialDegree | null
  civilProcedureRegime!: CivilProcedureRegime | null
  eurValueOverride!: number | null
  courtId!: string | null
  typeId!: string
  phaseId!: string
  userAssignments?: NewPracticeAssignment[]
  externalId!: string | null
}

export class NewCase {
  displayName!: string
  eurValue!: number | null
  externalId!: string | null
  portfolioId?: string | null
  firstPractice?: NewFirstPractice
}

export interface CaseCreated {
  case: {
    id: string
    practices?: { id: string }[]
  }
}

export class UpdateCase {
  displayName?: string
  eurValue?: number | null
  externalId?: string | null
  portfolioId?: string | null
}

export interface CaseUpdated {
  case: BaseCase
}

export class NewCaseRecordType extends NewAssignedRecordType {}

export class CaseRecordType extends AssignedRecordType {
  caseId!: string
}

export interface GetCaseRecordTypes {
  caseRecordTypes: CaseRecordType[]
}

export interface CaseRecordTypeWritten {
  caseRecordType: BaseEntity
}
